import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetTeams } from "../../api's/settings";

export const fetchTeamsDDL = createAsyncThunk(
  "teams/fetchTeamsDDL",
  async (token, { rejectWithValue }) => {
    try {
      const res = await GetTeams(token);
      const data = res?.data;

      if (data?.data?.is_success) {
        return data.data.data ?? [];
      } else {
        return rejectWithValue(data?.data?.message || "Failed to fetch teams");
      }
    } catch (err) {
      return rejectWithValue("Error fetching teams");
    }
  }
);

const teamSlice = createSlice({
  name: "teams",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTeams: (state) => {
      state.list = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamsDDL.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeamsDDL.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchTeamsDDL.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTeams } = teamSlice.actions;

export const teamReducer = teamSlice.reducer;
